var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebApplicationDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 16.875H43.125V20.625H39.375V16.875ZM39.375 22.5H43.125V26.25H39.375V22.5ZM33.75 16.875H37.5V20.625H33.75V16.875ZM33.75 22.5H37.5V26.25H33.75V22.5Z",
    fill: "#DC2418"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 30V35.625H18.75V20.625H30V18.75H18.75C18.2527 18.75 17.7758 18.9475 17.4242 19.2992C17.0725 19.6508 16.875 20.1277 16.875 20.625V35.625C16.875 36.1223 17.0725 36.5992 17.4242 36.9508C17.7758 37.3025 18.2527 37.5 18.75 37.5H26.25V41.25H22.5V43.125H37.5V41.25H33.75V37.5H41.25C41.7473 37.5 42.2242 37.3025 42.5758 36.9508C42.9275 36.5992 43.125 36.1223 43.125 35.625V30H41.25ZM31.875 41.25H28.125V37.5H31.875V41.25Z",
    fill: "#DC2418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApplicationDevelopment);
export default __webpack_public_path__ + "static/media/webApplicationDevelopment.a5a3f672cb6f9d8c56e19f65e25552a7.svg";
export { ForwardRef as ReactComponent };